import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import { Navigation } from "./components/Navigation";
import { HeroSection } from "./components/HeroSection";
import { PremiumWelcomeSection } from "./components/PremiumWelcomeSection";
import { PremiumSilentEpidemicSection } from "./components/PremiumSilentEpidemicSection";
import { ExpertiseSection } from "./components/ExpertiseSection";
import { MarketsSection } from "./components/MarketsSection";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider, useLanguage } from "./contexts/LanguageContext";
import { handleAnchorOnLoad } from "./utils/scrollToSection";

// Import all page components
import { NewAboutPage } from "./pages/NewAboutPage";
import { NewTriaxPage } from "./pages/NewTriaxPage";
import { NewServicesPage } from "./pages/NewServicesPage";
import { NewSignaturePage } from "./pages/NewSignaturePage";
import { SOSPage } from "./pages/SOSPage";
import { InsightsPage } from "./pages/InsightsPage";
import { KontaktPage } from "./pages/KontaktPage";
import { ImpressumPage } from "./pages/ImpressumPage";
import { DatenschutzPage } from "./pages/DatenschutzPage"; 
import { AGBPage } from "./pages/AGBPage";
import { WiderrufPage } from "./pages/WiderrufPage";

// ScrollToTop component - ensures pages open at top
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // Handle anchor links after navigation
    setTimeout(() => {
      handleAnchorOnLoad();
    }, 100);
  }, [location]);

  return null;
};

// Home page component
const HomePage = () => (
  <>
    {/* Hero Section */}
    <HeroSection />

    {/* Main Content Sections */}
    <main>
      {/* Welcome Section */}
      <PremiumWelcomeSection />

      {/* Silent Epidemic Section */}
      <PremiumSilentEpidemicSection />

      {/* What Makes Us Unique / Expertise */}
      <ExpertiseSection />

      {/* Markets & Regions */}
      <MarketsSection />
    </main>
  </>
);

// RTL-aware App Content
const AppContent = () => {
  const { language, isRTL } = useLanguage();

  useEffect(() => {
    // Set document direction based on language
    document.documentElement.dir = isRTL ? "rtl" : "ltr";
    document.documentElement.lang = language;
  }, [language, isRTL]);

  return (
    <div
      className={`App min-h-screen bg-white text-slate-900 font-sans ${
        isRTL ? "rtl" : "ltr"
      }`}
    >
      {/* Scroll to top on route change */}
      <ScrollToTop />

      {/* Navigation */}
      <Navigation />

      {/* Routes */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/uber-uns" element={<NewAboutPage />} />
        <Route path="/triax" element={<NewTriaxPage />} />
        <Route path="/services" element={<NewServicesPage />} />
        <Route path="/signature" element={<NewSignaturePage />} />
        <Route path="/sos" element={<SOSPage />} />
        <Route path="/insights" element={<InsightsPage />} />
        <Route path="/kontakt" element={<KontaktPage />} />
        <Route path="/impressum" element={<ImpressumPage />} />
        <Route path="/datenschutz" element={<DatenschutzPage />} />
         <Route path="/agb" element={<AGBPage />} />
        <Route path="/widerruf" element={<WiderrufPage />} />
            
      </Routes>

      {/* Footer */}
      <Footer />

      {/* Toast Notifications */}
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "white",
            color: "#0F172A",
            border: "1px solid #8B5CF6"
          }
        }}
      />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <Router>
        <AppContent />
      </Router>
    </LanguageProvider>
  );
}

export default App;
